/* eslint-disable no-unused-vars */
/**
 * Import 3rd party packages
 */

/**
 * Import modules / classes
 */
import PageScroll from "./modules/PageScroll";
import Tabs from "./modules/Tabs";
import Accordion from "./modules/Accordion";
import Swiper from "swiper/bundle";
import "swiper/css/bundle";
import NavbarMobile from "./modules/NavbarMobile";
import { WOW } from "wowjs/dist/wow.js";
import Rellax from "rellax/rellax.js";
import SimpleParallax from "simple-parallax-js";

/**
 * Instantiate a new object using imported modules/classes
 */
document.addEventListener("DOMContentLoaded", () => {
    const myPageScroll = new PageScroll();
    const myTabs = new Tabs("jsInfoTabs");
    const navbarMobile = new NavbarMobile();

    const infoAccordions = Array.from(
        document.querySelectorAll(".jsInfoAccordion")
    );
    if (infoAccordions.length) {
        infoAccordions.forEach((infoAccordion) => new Accordion(infoAccordion));
    }

    const swiper = new Swiper(".mySwiper", {
        direction: "vertical",
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
    });

    // wow js
    const wow = new WOW({
        live: false,
    });
    wow.init();

    // rellax
    if (window.innerWidth > 1279) {
        const rellax = new Rellax(".rellax");
    }
});
